export default {
  /** 查询用户基本信息 */
  queryUserInfo: '/userInfo/queryUserInfo',

  /** 同步用户信息 */
  syncUserInfo: 'userInfo/syncUserInfo',

  /** 圈子列表 */
  circleList: 'fans/circle/circleList',

  /** 圈子详情 */
  circleDetail: 'fans/circle/circleDetail',

  /** 圈子动态列表 */
  circleRecommendList: 'fans/circle/recommendList',

  /** 圈子关注/取消关注 */
  circleFollow: 'fans/follow/circleFollow',

  /** 用户关注/取消关注 */
  userFollow: 'fans/follow/userFollow',

  /** 话题关注/取消关注 */
  topicFollow: 'fans/follow/topicFollow',

  /** 圈子动态点赞 */
  contentFabulous: 'fans/circle/contentFabulous',

  /** 话题主页列表 */
  topicDetail: 'fans/circle/topicDetailApp',

  /** 动态明细 */
  contentDetail: 'fans/circle/contentDetail',

  /** 帖子删除 */
  contentDelete: 'fans/circle/contentDelete',

  /** 用户详细信息 */
  userDetail: 'fans/fansInfo/userDetail',

  /** 圈子动态访问计数 */
  contentVisits: 'fans/circle/contentVisits',

  /** 圈子动态评论 */
  commentList: 'fans/circle/commentList',

  /** 圈子动态子评论 */
  commentSubList: 'fans/circle/commentSubList',

  /** 圈子评论点赞 */
  commentFabulous: 'fans/circle/commentFabulous',

  /** 圈子动态评论单条删除 */
  commentDelete: 'fans/circle/commentDelete',

  /** 圈子动态评论置顶 */
  commentTop: 'fans/circle/commentTop',

  /** 发布评论 */
  pushComment: 'fans/circle/pushComment',

  /** 问答详情 */
  questionDetail: 'fans/discuss/questionDetail',

  /** 问答回答列表 */
  answerList: 'fans/discuss/answerList',

  /** 邀请有礼（注册-获取手机验证码） */
  getPhoneCode: 'captcha/getSmsCode',

  /** 邀请有礼注册 */
  inviteRegister: 'myself/inviteRegister',

  /** 省份列表 */
  provinces: 'region/province',

  /** 城市列表 */
  cities: 'region/city',

  /** 区县列表 */
  districts: 'region/district',

  /** 客户留资 */
  collect: 'appointment/driverCar',

  /** 车系详情 */
  carSeriesDetail: 'carSeries/detail',

  /** 车系列表 */
  simpleCarSeries: 'carSeries/simpleCarSeries',

  /** 文章详情 */
  articleDetail: 'article/detail',

  /** 问题列表 */
  questions: 'help/question/list',

  /** 推荐记录列表查询 */
  recommendRecords: 'recommend/getRecommendBuyingCarList',

  /** 我的推荐统计查询 */
  getRecommendCount: 'recommend/getRecommendCount',

  // 查询推荐人证件信息
  getRecommendCertInfo: 'recommend/getRecommendCertInfo',

  // 上传推荐人证件信息
  uploadCertInfo: 'recommend/uploadCertInfo',

  /** 车系配置 */
  carSeries: 'carSeries/carSeries',

  /** 订车意向 */
  bookingIntentionList: 'recommend/bookingIntentionList',

  /** 城市列表 */
  recommendBuyCar: 'recommend/recommendBuyCar',

  /** 佣金明细 */
  points: '/userpoint/queryPointList',

  recommendBuyCarDetail: '/recommend/recommendBuyCarDetail',

  /** 更新佣金提现收款账号 */
  updateAccountCashConfig: '/recommend/updateAccountCashConfig',

  /** 更新佣金提现收款账号 */
  getAccountCashConfig: '/recommend/getAccountCashConfig',

  /** 佣金信息 */
  myCashAccount: '/recommend/myCashAccount',

  /** 是否实名认证 */
  checkUserIsRealAuth: 'userInfo/checkUserIsRealAuth',

  /** 售后网点列表 */
  outletsList: '/outlets/survey/outletsList',

  /** 问卷保存 */
  surveySave: '/outlets/survey/save',

  /** 微信jsapi权限配置信息 */
  jsApiAuthConfig: '/util/wechat/jsApiAuthConfig',

  /** 推荐购车合作渠道列表 */
  channelList: 'recommend/channelList',

  /** 查询被推荐人小订记录列表 */
  recommendBookingOrderList: 'recommend/getRecommendBookingOrderList',

  /** 邀请人列表 */
  inviteList: 'myself/inviteList',

  /** 推荐类型 */
  getRecommendType: 'recommend/getRecommendType',

  /** 查询最新app渠道包下载地址 */
  queryLatestAppPackageUrl: 'appSysConfig/queryLatestAppPackageUrl',

  /** 意向征询 查询楼盘信息 */
  buildingList: 'intent/survey/buildings',

  /** 意向征询 保存 */
  saveSurvey: 'intent/survey/saveSurvey',

  /** 获取oss临时凭证 */
  getOssTicket: 'file/upload/cos/tmpCredential',

  /** 问题反馈提交 */
  feedbackCommit: 'feedback/commit',

  /** 预约单列表查询 */
  afterSaleReserveQueryList: 'afterSale/reserve/queryList',

  /** 预约单详情查询 */
  afterSalRreserveQueryInfo: 'afterSale/reserve/queryInfo',

  /** 维保工单列表查询 */
  afterSaleOrderQueryList: 'afterSale/order/queryList',

  /** 维保工单详情查询 */
  afterSaleOrderQueryInfo: 'afterSale/order/queryInfo',

  /** 售后门店列表分页查询 */
  afterSaleDlrListPage: 'afterSale/dlrList/page',

  /** 门店可预约时限列表查询 */
  afterSaleTimeListQuery: 'afterSale/timeList/query',

  /** 查询车辆列表 */
  vehicleCtrlMgtVehicleList: 'vehicle-ctrl/mgt/vehicleList',

  /** 提交预约单 */
  afterSaleReserveSubmit: 'afterSale/reserve/submit',

  /** 取消预约单 */
  afterSaleReserveCancel: 'afterSale/reserve/cancel',

  /** 提交维保工单评价 */
  afterSaleOrderComment: 'afterSale/order/comment',

  /** 实时订单数据 */
  orderCount: 'watch/orderCount',

  /** 查询活动内容征集记录 */
  getActContent: 'active/getActContent',

  /** 修改活动内容征集记录 */
  modifyActContent: 'active/modifyActContent',

  /** 提交活动内容征集记录 */
  submitActContent: 'active/submitActContent',

  /** 发送短信验证码 */
  sendSmsCode: 'captcha/getSmsCode',

  /** OCR识别 */
  vehicleAuthOcr: 'vehicle-auth/ocr',

  // 实名解绑
  vehicleAuth: 'vehicle-auth/unbind',

  // 查询实名认证信息详情接口
  vehicleauthDetail: 'vehicle-auth/detail',

  // 获取证件类型
  getAllCertTypes: 'vehicle-auth/getAllCertTypes',

  // 实名认证信息提交接口
  vehicleAuthSubmit: 'vehicle-auth/submit',

  // 车辆查询数据
  getVehicleInfo: 'vehicle-auth/getVehicleInfo',

  // 获取人脸识别结果
  faceDetectResult: 'vehicle-auth/faceDetectResult',

  // 上传正面照片
  uploadFacePic: 'vehicle-auth/uploadFacePic',

  // 根据字典类型查询字典数据集合
  getDictDataByType: 'dict/getDictDataByType',

  /** 待投票列表 */
  listActContentVotes: 'active/listActContentVotes',

  /** 投票 */
  vote: 'active/voteActContent',

  /** 获取小程序码 */
  getMpCode: 'third/getMpCode',

  /** 榜单列表 */
  listActContentAward: 'active/listActContentAward',

  /** 安装单提交 */
  installInfoCommit: 'evcharger/installation/apply',

  /** 可安装桩大定订单列表 */
  deliveryList: 'evcharger/delivery/big-booking-list',

  /** 发货单提交 */
  receiveInfoCommit: 'evcharger/delivery/apply',

  /** 查询用户订单列表 */
  queryOrderList: 'order/queryOrderList',

  /** 收货地址查询 */
  getUserShippingAddressList: 'userInfo/getUserShippingAddressList',

  /** 收货地址新增&修改 */
  saveUserShippingAddress: 'userInfo/saveUserShippingAddress',

  /** 收货地址删除 */
  deleteUserShippingAddress: 'userInfo/deleteUserShippingAddress',

  /** 查看服务评价 */
  evchargerInstallationGetReviews: 'evcharger/installation/get-reviews',

  /** 添加服务评价 */
  evchargerInstallationMakeReviews: 'evcharger/installation/make-reviews',

  /** 安装服务单详情 */
  installationDetail: 'evcharger/installation/detail',

  /** 发货服务单详情 */
  evchargerDeliveryDetail: 'evcharger/delivery/detail',

  /** 删除服务单 */
  serviceOrderDelete: 'service-order/delete',

  /** 安装服务单创建展示 */
  applyPreview: 'evcharger/installation/apply-preview',

  // 获取人脸识别链接
  faceDetectUrl: 'vehicle-auth/faceDetectUrl',

  /** 车辆使用手册-菜单列表 */
  carManualMenu: 'carManual/listNodes',

  /** 车辆使用手册-搜索 */
  carManualSearch: 'carManual/searchDetail',

  /** 车辆使用手册-文章详情 */
  carManualDetail: 'carManual/getDetail',

  /** 预约试驾门店查询 */
  expCenter: 'region/getDrivingStoreList',

  // 根据门店类型获取省份信息
  ProvincesByStoreType: 'region/getProvincesByStoreType',

  // 根据门店类型和省级code获取市级信息
  CitiesByStoreType: 'region/getCitiesByStoreType',

  // 获取待签署电子合同链接
  getEleSignUrl: 'contract/getEleSignUrl',
  // 内容聚合详情
  contentCollectionDetail: 'contentCollection/getDetail',

  // 内容聚合推荐列表
  contentCollectionList: 'contentCollection/getContentList',

  // 内容聚合收藏
  contentCollectionCollect: 'contentCollection/collectionCollect',

  // 智能辅助协议签署结果校验
  signInfoCheck: 'vehicle-adas/sign-info/check',

  // 智能辅助协议签署信息提交
  signInfoSubmit: 'vehicle-adas/sign-info/submit',

  // 活动详情查询
  activityInfoDetail: 'active/activityInfoDetail',
  // 活动列表
  activityInfoPageQuery: 'active/activityInfoPageQuery',

  // 活动预约提醒
  activityRemind: 'active/activityRemind',
  // 活动预约提醒取消
  activityRemindCancel: 'active/activityRemindCancel',
  // 报名取消
  activitySignCancel: 'active/activitySignCancel',
  // 报名查询
  activitySignQuery: 'active/activitySignQuery',
  // 报名提交
  activitySignSubmit: 'active/activitySignSubmit',
  // 我的活动列表
  myActivityInfoList: 'active/myActivityInfoList',
  // 活动报名用户列表
  queryActivitySignUpUserList: 'active/queryActivitySignUpUserList',
}
